import { useTranslation } from 'react-i18next';
import type { CausalClaim } from '@services/drbfm.mainline';

// Spans only: this renders inside a proposal field's <label>.
export default function FieldValue({ name, value }: { name: string; value: unknown }) {
  const { t } = useTranslation();
  if (name !== 'causal_claims' || !Array.isArray(value)) return <>{String(value ?? '')}</>;
  if (value.length === 0) return <>{t('drbfm.mainline.noCausalClaims')}</>;
  return <span role="list" className="grid gap-1">{(value as CausalClaim[]).map((c, i) =>
    <span role="listitem" key={i}>
      {[c.claim, t(`drbfm.mainline.evidence_${c.evidence_level}`), c.evidence].filter(Boolean).join(' · ')}
    </span>)}
  </span>;
}
